import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { IPayment } from '@getgreenline/homi-shared'
import { FormError } from '../../components/FormError'
import { Alert } from 'antd'
import { Track } from '../../Track'
import { parseErrorMsg } from '../../utilities/helpers'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  payment: IPayment
  onCancel: () => void
  onClose: () => void
  userId: string
}

interface State {
  isSaving: boolean
  completed: boolean
  errorMessage?: string
  notes: string | undefined
}

@inject('currentCompanyStore')
@observer
export class CancelPaymentModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
      completed: false,
      errorMessage: undefined,
      notes: undefined,
    }
  }

  cancel = async () => {
    const payment = this.props.payment
    this.setState({
      isSaving: true,
    })
    const { notes } = this.state
    const { userId } = this.props

    try {
      await this.props.currentCompanyStore!.cancelPayment(
        payment.locationId,
        payment.id,
        userId,
        notes,
      )
      Track.track('dashboard:payments_cancelled', payment)
      this.setState({
        completed: true,
        errorMessage: undefined,
      })
      this.props.onCancel()
    } catch (error) {
      this.setState({
        errorMessage: parseErrorMsg(error) || 'There was an error cancelling this sale',
      })
    } finally {
      this.setState({ isSaving: false })
    }
  }

  get warningMessage(): JSX.Element {
    const { payment } = this.props

    return (
      <ul className='no-margin-list pl-0'>
        <li>Inventory will be returned when cancelling this sale.</li>

        {payment.externalOrderId !== null && (
          <li>
            Parked sale ID <b>{payment.externalOrderId}</b> will also be cancelled.
          </li>
        )}
      </ul>
    )
  }

  render() {
    const { notes } = this.state

    let body: JSX.Element
    if (!this.state.completed) {
      body = (
        <div>
          <Alert
            showIcon
            type='warning'
            className='mb-3'
            message='Warning'
            description={this.warningMessage}
          />

          {this.props.payment.wooCommerceOrderId !== null && (
            <Alert
              message='Note'
              className='mb-3'
              description={
                <span>
                  Your WooCommerce order ID: <b>{this.props.payment.wooCommerceOrderId}</b>
                </span>
              }
              type='info'
              showIcon
            />
          )}

          <div>
            {this.state.isSaving ? (
              <button className='btn btn-lg btn-danger w-100' disabled>
                Cancelling...
              </button>
            ) : (
              <div>
                <textarea
                  className='form-control'
                  placeholder='Notes'
                  rows={3}
                  value={notes}
                  onChange={(e) => this.setState({ notes: e.target.value || undefined })}
                />
                <br />
                <button className='btn btn-lg btn-danger w-100' onClick={() => this.cancel()}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      )
    } else {
      body = (
        <div style={{ textAlign: 'center' }}>
          <br />
          <div className='fa fa-check mb-1' style={{ fontSize: '7em', color: 'green' }} />
          <p>This sale has been successfully cancelled.</p>
          <br />
        </div>
      )
    }

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()} autoFocus={false}>
        <ModalHeader toggle={() => this.props.onClose()}>Cancel sale</ModalHeader>
        <ModalBody>
          {body}
          <FormError message={this.state.errorMessage} />
        </ModalBody>
      </Modal>
    )
  }
}
